// GEO_EXEC_R9 · one custom domain per GEO site.
//
// Addressed by SITE id, not brand id — that is the PRD's shape and `/api/sites` carries the id for
// exactly this. The three writes are Autopilot-gated (402); the read is not, so a client who is
// not on the plan can still open the panel and see what it would do.

import { api } from "./client";

export function getSiteDomain(siteId, { signal } = {}) {
  return api(`/api/geo-exec/r9/sites/${encodeURIComponent(siteId)}/domain`, { signal });
}

export function saveSiteDomain(siteId, host, { signal } = {}) {
  return api(`/api/geo-exec/r9/sites/${encodeURIComponent(siteId)}/domain`, {
    method: "POST",
    json: { host },
    signal,
  });
}

export function recheckSiteDomain(siteId, { signal } = {}) {
  return api(`/api/geo-exec/r9/sites/${encodeURIComponent(siteId)}/domain/recheck`, { method: "POST", signal });
}

export function removeSiteDomain(siteId, { signal } = {}) {
  return api(`/api/geo-exec/r9/sites/${encodeURIComponent(siteId)}/domain`, { method: "DELETE", signal });
}
